import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';

import { TableColumnDef } from '../abstract/table-base.component';

@Component({
    selector: 'app-table-column-picker',
    imports: [
        CommonModule,
        FormsModule,
        CheckboxModule,
        TableModule,
    ],
    templateUrl: './table-column-picker.component.html',
    styleUrl: './table-column-picker.component.scss'
})
export class TableColumnPickerComponent implements OnChanges {

    @Input() public columns: TableColumnDef[] = [];
    @Output() public onChangeColumnsConfig = new EventEmitter<TableColumnDef[]>();

    public items: TableColumnDef[] = [];

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['columns']) {
            this.items = [...this.columns];
        }
    }

    public onRowReorder(): void {
        this.onChangeColumnsConfig.emit([...this.items]);
    }

    public onVisibilityChange(): void {
        this.onChangeColumnsConfig.emit([...this.items]);
    }
}
